import { useEffect } from "react";

import { useCan, useSelectedDealer } from "components";
import { useTypedQuery } from "hooks";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { TyreDiscountsDashboardQueryKeys } from "modules/TyreDiscountsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useDiscountsQuery = () => {
  const { selectedDealer } = useSelectedDealer();
  const canListTyreDiscounts = useCan(ACL_ACTIVITIES.List, ACL_RESOURCES.TyreDiscounts);

  const query = useTypedQuery({
    queryKey: TyreDiscountsDashboardQueryKeys.discounts,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { dealer_id: selectedDealer?.id }, baseUrl)).data.tyre_discounts,
    enabled: canListTyreDiscounts && Boolean(selectedDealer?.id)
  });

  useEffect(() => {
    if (canListTyreDiscounts && selectedDealer?.id) query.refetch();
  }, [selectedDealer?.id]);

  return query;
};
